import { Link } from "react-router-dom";
import PageHead from "../components/PageHead";
import { Arr } from "../components/CTA";

const Tick = () => (
  <svg className="tick" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M4 10.5l4 4 8-9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Contact() {
  const onSubmit = (e) => {
    e.preventDefault();
    const g = (id) => (document.getElementById(id)?.value || "").trim();
    const subject = "Docket pilot enquiry · " + (g("company") || "new enquiry");
    const body =
      "Name: " + g("name") +
      "\nWork email: " + g("email") +
      "\nCompany: " + g("company") +
      "\nDocument types of interest: " + g("doctypes") +
      "\n\n" + g("message");
    window.location.href =
      "mailto:hello@devnco.in?subject=" + encodeURIComponent(subject) +
      "&body=" + encodeURIComponent(body);
  };

  return (
    <>
      <PageHead
        crumb="Request a pilot"
        eyebrow="Request a pilot"
        title="Put Docket in front of your documents."
        lede="The fastest way to evaluate Docket is to watch it learn the documents your team handles every day. Tell us what they are, we will take it from there."
      />

      <section className="section">
        <div className="container">
          <div className="contact-grid">

            <div className="reveal">
              <h2 style={{ fontSize: 27, marginBottom: 8 }}>Tell us about your documents</h2>
              <p style={{ color: "var(--ink-soft)", marginBottom: 28, maxWidth: "42ch" }}>
                A few details are enough to get started. We will reply to arrange a short call.
              </p>
              <form className="form" id="pilotForm" noValidate onSubmit={onSubmit} data-testid="pilot-form">
                <div className="field">
                  <label htmlFor="name">Your name</label>
                  <input type="text" id="name" name="name" autoComplete="name" required data-testid="form-name" />
                </div>
                <div className="field">
                  <label htmlFor="email">Work email</label>
                  <input type="email" id="email" name="email" autoComplete="email" required data-testid="form-email" />
                </div>
                <div className="field">
                  <label htmlFor="company">Company</label>
                  <input type="text" id="company" name="company" autoComplete="organization" required data-testid="form-company" />
                </div>
                <div className="field">
                  <label htmlFor="doctypes">
                    Document types you'd like to process <span className="opt">(optional)</span>
                  </label>
                  <input type="text" id="doctypes" name="doctypes" placeholder="e.g. supplier invoices, bills of lading" data-testid="form-doctypes" />
                </div>
                <div className="field">
                  <label htmlFor="message">
                    Anything else we should know? <span className="opt">(optional)</span>
                  </label>
                  <textarea id="message" name="message" placeholder="Volumes, current process, timelines, questions…" data-testid="form-message" />
                </div>
                <button type="submit" className="btn btn--primary" data-testid="form-submit">
                  Send pilot request <Arr />
                </button>
                <p className="form__note">This opens a pre-filled email to our team at hello@devnco.in. We typically reply within two business days.</p>
              </form>
            </div>

            <div className="reveal d1">
              <aside className="pilot-aside">
                <h2>What a pilot includes</h2>
                <p style={{ color: "var(--ink-soft)", fontSize: 14.5, marginBottom: 4 }}>A focused, time-boxed engagement on your own documents, not a generic demo.</p>
                <ul className="aside-list">
                  <li><Tick /><span><strong>Four to six weeks</strong>: a clear scope and a clear end date.</span></li>
                  <li><Tick /><span><strong>Two or three document types</strong> chosen with you for real impact.</span></li>
                  <li><Tick /><span><strong>Trained, working models</strong> running in an isolated tenant.</span></li>
                  <li><Tick /><span><strong>A measured accuracy baseline</strong>: confidence on your data, not ours.</span></li>
                  <li><Tick /><span><strong>A clear view of the automation gain</strong> to take to your team.</span></li>
                </ul>
                <div className="contact-meta">
                  Prefer email? Reach us directly at <a href="mailto:hello@devnco.in">hello@devnco.in</a>.<br />
                  Docket is built by Devnco Technologies Pvt. Ltd., Pune, India.
                </div>
              </aside>
            </div>

          </div>
        </div>
      </section>

      {/* CLOSING STRIP */}
      <section className="section--tight pilot-close">
        <div className="container">
          <div className="s-head s-head--center reveal" style={{ marginBottom: 0 }}>
            <div className="eyebrow eyebrow--center">Not ready yet?</div>
            <h2 style={{ fontSize: "clamp(24px,3vw,32px)", marginBottom: 18 }}>Have a look around first.</h2>
            <div className="cta__actions" style={{ justifyContent: "center" }}>
              <Link to="/how-it-works" className="btn btn--ghost">See how it works</Link>
              <Link to="/platform" className="btn btn--ghost">Explore the platform</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
